import React, { useEffect, useRef } from 'react';
import { Trash2, MessageSquare } from 'lucide-react';

const fmt = (ts) => {
  const d = new Date(ts);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};

/**
 * ConversationHistory — chronological vocalized phrases, auto-scrolling.
 */
export default function ConversationHistory({ items, onClear }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    // smooth scroll to bottom on new entry
    el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
  }, [items.length]);

  return (
    <div className="sv-card p-4 sm:p-5 flex flex-col" data-testid="history-card" style={{ minHeight: 220 }}>
      <div className="flex items-center justify-between mb-3">
        <p className="sv-eyebrow">History</p>
        <button
          className="sv-btn-mini"
          onClick={onClear}
          disabled={items.length === 0}
          data-testid="history-clear-btn"
          title="Clear history"
        >
          <Trash2 className="w-3.5 h-3.5" />
          <span>Clear</span>
        </button>
      </div>
      <div ref={scrollRef} className="sv-history-list" data-testid="history-list">
        {items.length === 0 ? (
          <div className="sv-history-empty" data-testid="history-empty">
            <MessageSquare className="w-5 h-5 mb-2" style={{ color: 'var(--sv-violet-bright)' }} />
            <p className="text-sm" style={{ color: 'var(--sv-text-dim)' }}>
              No spoken phrases yet.
            </p>
          </div>
        ) : (
          <ul className="space-y-2">
            {items.map((it) => (
              <li key={it.id} className="sv-history-item" data-testid="history-item">
                <span className="sv-history-text">{it.text}</span>
                <span className="sv-history-time mono">{fmt(it.ts)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
